import { useNavigate } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import { useAuthContext } from "../../../hooks/useAuthContext";
import TrainingsListComponent from "../components/TrainingsListComponent";

const SecretariatClassesListPage = () => {
  //
  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  //
  const listRef = useRef();
  //
  //
  return (
    <>
      <MeaPage
        title="De quelle formation ?"
        breadcrumb={<SecretariatWorkspaceBar section="classes" />}
        showBackButton={true}
        onBackButtonClick={() => navigate(`/school/${currentMembership?.school?.id}/secretariat`)}
      >
        <TrainingsListComponent
          ref={listRef}
          showAddButton={true}
          redirectPath="classes"
        />
      </MeaPage>
    </>
  );
};

export default SecretariatClassesListPage;
